// TokenExpiryCheckWrapper.js
import React from "react";
import { useLocation } from "react-router-dom";
import useTokenExpiryCheck from "./UseTokenExpiryCheck";

const TokenExpiryCheckWrapper = () => {
  // Ensure we have access to the location context
  const location = useLocation();
  useTokenExpiryCheck(location); // Pass the location if needed. Your hook might need to adjust based on this.

  return null; // This component doesn't render anything itself
};

export default TokenExpiryCheckWrapper;
